<label class="bz-radio" [class.bz-radio--disabled]="isDisabled()">
  <input
    type="radio"
    class="bz-radio__input"
    [name]="group.name()"
    [value]="value()"
    [checked]="checked()"
    [disabled]="isDisabled()"
    [attr.aria-label]="ariaLabel() || null"
    (change)="group.select(value())"
    (blur)="group.markTouched()"
  />
  <span class="bz-radio__label"><ng-content /></span>
</label>
